const DelimiterBlock = () => {
    return (
        <hr className={`re-delimiter`}/>
    );
}

export default DelimiterBlock;
